import { Mutation, Action, VuexModule, getModule, Module } from 'vuex-module-decorators';
import { RootState, store } from '../..';
import { Tag } from '@/models/tag';
import { tagService } from '@/service/api/tag.service';

export interface ITagState {
  tags: Tag[]; // タグ情報
}
@Module({ dynamic: true, store, name: 'tagModule', namespaced: true })
class TagModule extends VuexModule implements ITagState {
  tags: Tag[] = [];

  get selectedTagContents(): string[] {
    return this.tags.filter((tag: Tag) => tag.flg).map((tag: Tag) => tag.tagContent);
  }

  @Mutation
  setTags(value: Tag[]) {
    this.tags = value;
  }

  @Mutation
  addTag(value: Tag) {
    this.tags.push(value);
  }

  @Mutation
  deleteTag(value: string) {
    const deleteTagIndex: number = this.tags.findIndex((tag: Tag) => {
      return tag.tagContent === value;
    });
    this.tags.splice(deleteTagIndex, 1);
  }
  /**
   * タグ情報一覧取得
   */
  @Action({ rawError: true })
  async fetchTags(headers: any = {}) {
    const result = await tagService.getTags(headers);
    this.setTags(result);
  }
}

export const tagModule = getModule(TagModule);
